/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    clubs: ''
  },
  mutations: {
    setClubsData (state, {clubs}) {
      state.clubs = clubs
    },
    reset (state) {
      state.clubs = ''
    }
  },
  actions: {
    getAdminClub ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('admin/club')
        .then((response) => {
          var clubs = response.data
          commit('setClubsData', {clubs})
          resolve(clubs)
        }).catch((error) => {
          reject(error)
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Clubs.js